<template>
  <a-layout>

     <a-layout-header style="background: #fff; padding: 0">
      <span class="header-title">
        Preferences
      </span>
    </a-layout-header>

    <a-row type="flex" justify="space-around" align="middle">
      <a-col style="width: 100%;">

        <a-card
          class="pref-card"
          :bordered="false"
          >

          <a-tabs default-active-key="1" :animated="false">
            <a-tab-pane key="1" tab="Planner">

              <div class="option">
                <div>Weekdays shown</div>
                <div>
                  <a-checkbox-group
                    v-model="prefWeekdays"
                    :options="weekdays"
                    />
                </div>
              </div>

            </a-tab-pane>

            <a-tab-pane key="2" tab="Boards" force-render>
              <i>Nothing here yet</i>
            </a-tab-pane>

            <a-tab-pane key="3" tab="Layout" force-render>

              <div class="option">
                <a-checkbox v-model="prefShowDragHandle" />
                <span>Hide drag handle <a-icon type="ellipsis"></a-icon> on todos (you can still drag the checkbox)</span>
              </div>

            </a-tab-pane>

          </a-tabs>

          <div class="footer">
            <i>Note: Preferences are stored locally in your browser to allow different configurations on different devices.</i>
          </div>

        </a-card>

      </a-col>
    </a-row>

  </a-layout>
</template>

<script>
import moment from 'moment';

export default {
  name: "UserPreferences",
  computed: {
    prefWeekdays: {
      get() {
        let prefWeekdaysAsNumbers = this.$store.getters["prefs/getUserPreferences"]["planner.weekdays"];
        return prefWeekdaysAsNumbers.map(String);
      },
      set(value) {
        let prefWeekdaysAsNumbers = value.map(x=>+x);
        prefWeekdaysAsNumbers.sort(function (a, b) {return a - b;});
        this.$store.commit(
          "prefs/setPreference",
          {key: "planner.weekdays", value: prefWeekdaysAsNumbers}
        );
      }
    },
    prefShowDragHandle: {
      get() {
        return this.$store.getters["prefs/getUserPreferences"]["layout.hideDragHandle"];
      },
      set(value) {
        // TODO: why is value sometimes event? maybe update vue?
        // see: https://github.com/vueComponent/ant-design-vue/issues/1356
        if (typeof value == "boolean") {
          this.$store.commit(
            "prefs/setPreference",
            {key: "layout.hideDragHandle", value: value}
          );
        }
      }
    }
  },
  data() {
    return {
      weekdays: [
        {"label": moment.weekdays(true, 0), value: "0"},
        {"label": moment.weekdays(true, 1), value: "1"},
        {"label": moment.weekdays(true, 2), value: "2"},
        {"label": moment.weekdays(true, 3), value: "3"},
        {"label": moment.weekdays(true, 4), value: "4"},
        {"label": moment.weekdays(true, 5), value: "5"},
        {"label": moment.weekdays(true, 6), value: "6"},
      ]
    }
  }
}
</script>

<style scoped>

.footer {
  margin-top: 25px;
}

.header-title {
  margin-left: 15px;
  color: rgba(0, 0, 0, 0.55);
  display: flex;
  float: left;
  font-size: 1.5em;
}

.option {
  margin-top: 10px;
}

.pref-card {
  margin: 15px;
}

</style>

